import type { Image3DRowFormat } from '@/formats/UnitParser';
import { BLC } from '@/data';

export class StructureSVGParser {
  static generateSvgFromRows(
    rows: Image3DRowFormat[],
  ): string {
    return rows
      .map(this.getLinesInfoToGenerateSVG)
      .map((value) => this.generateLine(
        value.xList,
        value.y,
        value.endX,
      ))
      .join('<!-- LINE -->');
  }

  private static getLinesInfoToGenerateSVG(row: Image3DRowFormat) {
    const lastXOnsetIndex = row['onset-x'].length - 1;
    const endX = row['onset-x'][lastXOnsetIndex].x;
    return {
      xList: StructureSVGParser.getXListOf(row),
      y: row.y,
      endX,
    };
  }

  private static getXListOf(row: Image3DRowFormat): number[] {
    return row['onset-x'].map((XOnset) => XOnset.x);
  }

  private static generateLine(xList: number[], yLine: number, endX: number) {
    return xList.map((x, index, array) => {
      const nextX = array[index + 1] || endX;
      const width = nextX - x;
      if (width !== 0) {
        return this.generateCell(x, yLine, width, BLC.rowHeight);
      }
      return '';
    }).join('');
  }

  private static generateCell(x: number, y: number, width: number, height: number): string {
    const verticalPadding = 0;
    const xShiftToAlignWithLabels = 0;
    return `<rect x="${x - xShiftToAlignWithLabels}" y="${y - verticalPadding}" width="${width}" height="${height + 2 * verticalPadding}" class="structure"></rect>`;
  }
}
